import { useQuery } from "@tanstack/react-query";
import { getLeadsCampaigns } from "Infrastructure/Api/Api";
import { MS_TIME } from "Utils/TimeUtils";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import type { EntityListOfCampaignDto } from "Infrastructure/Api/Api";

const LEADS_CAMPAIGNS_QUERY_KEY = "LEADS_CAMPAIGNS";

export const leadsCampaignsKeys = {
  all: [LEADS_CAMPAIGNS_QUERY_KEY] as const,
  paginated: (pageSize?: number, pageNumber?: number) =>
    [...leadsCampaignsKeys.all, pageSize ?? null, pageNumber ?? null] as const,
};

export const useLeadsCampaignsQuery = (
  pageSize?: number,
  pageNumber?: number,
) =>
  useQuery<EntityListOfCampaignDto>({
    queryKey: leadsCampaignsKeys.paginated(pageSize, pageNumber),
    queryFn: processResponseWithApiProblemDetails(() =>
      getLeadsCampaigns(pageSize, pageNumber),
    ),
    refetchOnWindowFocus: false,
    staleTime: MS_TIME.minute,
  });
